import axios from "axios";
import {
  ENTER_PASSWORD,
  GET_SUBMISSIONS,
  GET_COMMENTS,
  SUBMISSIONS_LOADING,
  DELETE_COMMENT,
  CHANGE_SUBMISSION,
  GET_VISITORS
} from "./types";

import { displayError, getProcesses } from "./processActions";
import { openApprovalModal } from "./modalActions";

export const enterPassword = password => dispatch => {
  dispatch({ type: ENTER_PASSWORD, payload: password });
};

export const getSubmissions = password => dispatch => {
  dispatch(setSubmissionsLoading());

  axios
    .get("/aledatabase/api/approve.php", { params: { password } })
    .then(res => {
      if (!res.data.success) {
        dispatch(displayError(res.data.reason));
        dispatch(enterPassword(""));
        return;
      }
      dispatch({ type: GET_SUBMISSIONS, payload: res.data });
      dispatch(openApprovalModal());
    });
};

export const setSubmissionsLoading = () => {
  return { type: SUBMISSIONS_LOADING };
};

export const approveProcess = (process, password) => dispatch => {
  delete process.references;
  console.log(process);

  axios
    .patch("/aledatabase/api/processes.php", { password, ...process })
    .then(res => {
      if (!res.data.success) {
        dispatch(displayError(res.data.reason));
        return;
      }
      dispatch(getProcesses());
    });

  dispatch(getSubmissions(password));
};

export const approveReference = (reference, password) => dispatch => {
  delete reference.references;

  axios
    .patch("/aledatabase/api/references.php", { password, ...reference })
    .then(res => {
      if (!res.data.success) {
        dispatch(displayError(res.data.reason));
        return;
      }
      dispatch(getProcesses());
    });

  dispatch(getSubmissions(password));
};

export const removeProcess = (process, password) => dispatch => {
  delete process.references;

  axios
    .delete("/aledatabase/api/processes.php", {
      params: { password, ...process }
    })
    .then(res => {
      if (!res.data.success) {
        dispatch(displayError(res.data.reason));
        return;
      }
      dispatch(getProcesses());
    });

  dispatch(getSubmissions(password));
};

export const removeReference = (reference, password) => dispatch => {
  delete reference.references;

  axios
    .delete("/aledatabase/api/references.php", {
      params: { password, ...reference }
    })
    .then(res => {
      if (!res.data.success) {
        dispatch(displayError(res.data.reason));
        return;
      }
      dispatch(getProcesses());
    });

  dispatch(getSubmissions(password));
};

export const getComments = password => dispatch => {
  axios
    .get("/aledatabase/api/comments.php", { params: { password } })
    .then(res => {
      if (!res.data.success) {
        dispatch(displayError(res.data.reason));
        return;
      }

      dispatch({ type: GET_COMMENTS, payload: res.data.comments });
    });
};

export const deleteComment = (id, password) => dispatch => {
  axios
    .delete("/aledatabase/api/comments.php", { params: { id, password } })
    .then(res => {
      if (!res.data.success) {
        dispatch(displayError(res.data.reason));
        return;
      }
      dispatch({ type: DELETE_COMMENT, payload: id });
    });

  //dispatch(getComments());
};

export const changeSubmission = (key, value) => dispatch => {
  dispatch({ type: CHANGE_SUBMISSION, payload: { key, value } });
};

export const addVisitor = () => dispatch => {
  axios.post("/aledatabase/api/visitors.php").then(res => {
    if (!res.data.success) {
      dispatch(displayError(res.data.reason));
      return;
    }

    dispatch({ type: GET_VISITORS, payload: res.data.visitors });
  });
};

export const getVisitors = () => dispatch => {
  axios.get("/aledatabase/api/visitors.php").then(res => {
    if (!res.data.success) {
      dispatch(displayError(res.data.reason));
      return;
    }

    dispatch({ type: GET_VISITORS, payload: res.data.visitors });
  });
};
